<template>
  <div class="slds-form-element slds-size--medium">

    <!-- Label -->
    <label class="slds-form-element__label" for="select-campaign-type">
      <abbr class="slds-required" title="required">*</abbr>{{ $t('campaignDesigner.campaignSetup.type.label') }}
    </label>

    <!-- Picklist -->
    <div class="slds-combobox_container" v-click-outside="{callback: closeEvent, enable: true}">
      <div class="slds-combobox slds-dropdown-trigger slds-dropdown-trigger_click" :class="{'slds-is-open': open}" aria-expanded="false" aria-haspopup="listbox" role="combobox">
        <div class="slds-combobox__form-element slds-input-has-icon slds-input-has-icon_right value-container" role="none" :class="{'slds-has-error': !valid}">
          <span class="slds-swatch type-color-container" :style="`background:${localValue.color ? localValue.color: '#FFFFFF'};`" />
          <input :disabled="disabled" type="text" class="slds-input slds-combobox__input" :id="`select-campaign-type`" aria-controls="listbox-id-1" readonly autoComplete="off" role="textbox" :placeholder="placeholder" @click="toggleOpen" v-click-outside="{callback: closeEvent, enable: true}"/>
          <span class="slds-icon_container slds-icon-utility-down slds-input__icon slds-input__icon_right">
            <svg class="slds-icon slds-icon slds-icon_x-small slds-icon-text-default" aria-hidden="true">
              <use xlink:href="../../../../assets/symbols.svg#down"></use>
            </svg>
          </span>
        </div>
        <div class="slds-form-element__help error" v-if="!valid && !open">{{ error }}</div>

        <div id="listbox-id-1" class="slds-dropdown slds-dropdown_length-5 slds-dropdown_fluid" role="listbox" v-if="localOptions.length">
          <ul class="slds-listbox slds-listbox_vertical" role="presentation">
            <li role="presentation" class="slds-listbox__item" v-for="option in localOptions" :key="option.name" @click="toggleItemSelection(option)">
              <div id="option1" class="slds-media slds-listbox__option slds-listbox__option_plain slds-media_small" role="option">
                <span class="slds-media__figure slds-listbox__option-icon" v-if="isItemSelected(option)">
                  <span class="slds-icon_container slds-icon-utility-check slds-current-color">
                    <svg class="slds-icon slds-icon_x-small selected" aria-hidden="true">
                      <use xlink:href="../../../../assets/symbols.svg#check" ></use>
                    </svg>
                  </span>
                </span>
                <span class="slds-media__body">
                  <span class="slds-swatch" :style="`background:${option.color}`">
                    <span class="slds-assistive-text">{{option.color}}</span>
                  </span>
                  <span class="slds-truncate" :title="option.label">{{option.label}}</span>
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Validator from '../../../../validation/Validator.vue'
export default {
  mixins: [Validator],
  computed: {
    placeholder () {
      if (this.localValue.label) {
        return this.localValue.label
      } else {
        return this.$tc('picklist.values', 0, { count: 0 })
      }
    }
  },
  props: {
    disabled: Boolean,
    options: Array,
    value: Object
  },
  data () {
    return {
      open: false,
      localOptions: [],
      localValue: {
        color: '',
        name: ''
      }
    }
  },
  methods: {
    isItemSelected (value) {
      return this.localValue.value === value.value
    },
    toggleOpen () {
      if (!this.disabled) {
        this.open = !this.open
      }
    },
    closeEvent () {
      if (this.open) {
        this.open = false
      }
    },
    toggleItemSelection (option) {
      this.localValue = option

      this.$emit('input', this.localValue)
      this.open = false
      this.clearValidationError()
    },
    mapLocalOptions (options) {
      this.localOptions = options.map(option => {
        return {
          color: option.color,
          department: option.department,
          disableOrchestrationFlagDefault: option.disableOrchestrationFlagDefault,
          disableOrchestrationFlagEditable: option.disableOrchestrationFlagEditable,
          label: option.name,
          value: option.code
        }
      })
    }
  },
  watch: {
    disabled () {
      this.localValue = { color: '', department: '', name: '', disableOrchestrationFlagDefault: false, disableOrchestrationFlagEditable: false }
    },
    options (options) {
      this.localValue = { color: '', department: '', name: '', disableOrchestrationFlagDefault: false, disableOrchestrationFlagEditable: false }
      this.localOptions = options
      this.mapLocalOptions(this.options)
    },
    value (value) {
      this.localValue = value
    }
  },
  created () {
    if (this.value) {
      this.localValue = this.value
    }

    this.mapLocalOptions(this.options)

    this.$store.watch((state, getters) => getters['session/locale'],
      newValue => {
        this.mapLocalOptions(this.options)
      })
  }
}
</script>
<style lang="scss" scoped>
  .selected {
    fill: #4589EE;
  }

  .selection-box {
    height: fit-content;
  }

  svg {
    cursor: pointer;
  }

  .error {
    color: #C23933
  }

  .slds-swatch {
    margin-right: 10px;
  }

  .value-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
